'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)t = s[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)t = s[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const ResponsiveImage = renderWithRef('ResponsiveImage', null, (t, o)=>{
    var { children: n } = t;
    return jsx(RenderComp, {
        root: "img",
        classNames: [
            'swan-responsive-image'
        ],
        forwardedRef: o,
        props: _object_without_properties(t, [
            "children"
        ]),
        children: n
    });
});

export { ResponsiveImage };
